import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { OrgTypeWithRole } from 'src/@types/org';
import { CustomAvatar } from 'src/components/custom-avatar';
import { CommandPaletteResult } from 'src/components/command-palette';
import { formatOrgSubheader } from 'src/utils/formatOrgSubheader';

type OrgSwitcherRowBaseProps = {
  org: OrgTypeWithRole;
  actions?: ReactNode;
  onClick?: () => void;
};

export default function OrgSwitcherRowBase({ org, actions, onClick }: OrgSwitcherRowBaseProps) {
  return (
    <CommandPaletteResult onClick={onClick}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <CustomAvatar src={org.signed_url} alt={org.name} name={org.name} />
          <Box>
            <Typography variant="subtitle1">{org.name}</Typography>
            <Typography variant="caption">{formatOrgSubheader(org)}</Typography>
          </Box>
        </Stack>

        {actions}
      </Stack>
    </CommandPaletteResult>
  );
}
